import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AsignacionAlumnoModal } from "@contenido/AppContent/global/asignacionalumno/asignacionalumno.component";
import { ColaboradorEvaluacionModalComponent } from "@contenido/AppContent/global/colaboradorevaluacion/colaboradorevaluacion.component";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { SistemaService } from "@servicios/Sistema.Service";


@Component({
    selector: 'asignacionevaluacionpadresform',
    templateUrl: './asignacionevaluacionpadresform.component.html',
    styleUrls: ['./asignacionevaluacionpadres.component.scss']
})

export class AsignacionEvaluacionPadresFormComponent implements AfterViewInit{
    consulta!: boolean;
    entidad: PeriodoEvaluacion;
    public animacion!: string;
    @Input() accion!: {accion: string, entidad:any};
    @Input() id!: number;
    @Input() identificador!: number;
    @Input() nivelid!: number;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() cicloid!: number;
    @Input() gradoid!: number;
    @Input() tipoevaluacionid!: number;
    @Output() output = new EventEmitter();

    @ViewChild('colaborador') private colaborador!: ColaboradorEvaluacionModalComponent;

    @ViewChild('asignacionalumno') private asignacionalumno!: AsignacionAlumnoModal;

    cambio: boolean = false;
    collapsed = false;
    listacolaborador: any[];
    colaboradorguardar: any[];
    Datapadresmaestros: any[];
    cantidadalumnoaleatorio: number = 0;

    condicion:boolean = false;

    public errorActivo!: boolean;

    abierto:boolean = false;

    visualizador: boolean = false;
    textoselect: string = "always";

    DataMaterias: any[] = [];
    selectedRows: any[] = [];

    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService){
        this.entidad = new PeriodoEvaluacion();
        this.listacolaborador = [];
        this.colaboradorguardar = [];
        this.Datapadresmaestros = [];
    }

    ngAfterViewInit(){
        if (this.identificador == 1) {
            this.visualizador = true;
            this.textoselect = "none"
        }
        this.SetPadreMaestro();
        //this.SetMateria();
    }

    onInitialized(e: any) {
        e.component.columnOption("command:expand", "width", 20);
    }

    SetMateria() {
        this.appService.Post("planeacion/asignacionevaluacion/alumno/materia/buscar", {"gradoid": this.accion.entidad.gradoid, "cicloid": this.entidad.cicloid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataMaterias = res.data;
                if(this.DataMaterias.length > 0){
                    this.SetMateriasPorPeriodoEvaluacion();
                }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen registros asignados");
                }
            }
        })
    }

    SetMateriasPorPeriodoEvaluacion() {
        this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestro", {"cicloid": this.entidad.cicloid, "periodoevaluacionid": this.entidad.periodoevaluacionid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let valor of res.data) {
                    if(this.identificador == 1){
                        let materia = this.DataMaterias.find(x => x.profesorpormateriaplanestudiosid == valor.profesorpormateriaplanestudiosid);
                        if (materia) {
                            materia.activo = true;
                        }
                    }else{
                        let materia = this.DataMaterias.find(x => x.profesorpormateriaplanestudiosid == valor.profesorpormateriaplanestudiosid);
                        if (materia) {
                            this.selectedRows.push(materia);
                        }
                    }

                }
            }
        })
    }

    contentReady(e: any) {
        if (!this.collapsed) {
            this.collapsed = true;
            e.component.expandRow(['EnviroCare']);
        }
    }

    GuardarColaborador(entidad:any){
        this.colaboradorguardar = entidad;
        if(this.condicion){
            this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestroguardar",{"listacolaborador":this.colaboradorguardar, "cantidadalumno":this.cantidadalumnoaleatorio,"periodoevaluacionid":this.entidad.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.entidad.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid, "gradoid":this.accion.entidad.gradoid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid, "tipoasignacionid": this.accion.entidad.tipoasignacionid}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.asignacionalumno.listacolaboradores = [];
                    if(this.listacolaborador.length == 0){
                        this.listacolaborador = this.colaboradorguardar;
                    }else{
                        for(let col of this.colaboradorguardar){
                            this.listacolaborador.push(col);
                        }
                    }
                    this.colaboradorguardar = [];
                    this.asignacionalumno.periodoevaluacionportipoevaluacionid = 0;
                    this.cantidadalumnoaleatorio = 0;
                    this.colaborador.listcolaboradorduplicado = [];
                    this.condicion = false;
                    this.colaborador.CerrarModal();
                    this.CerrarModalInterno();
                    this.SetPadreMaestro();
                }
            })
        }else{
            this.asignacionalumno.listacolaboradores = [];
            this.asignacionalumno.listacolaboradores = entidad;
            this.asignacionalumno.periodoevaluacionportipoevaluacionid = this.periodoevaluacionportipoevaluacionid;
            this.asignacionalumno.gradoid = this.accion.entidad.gradoid;
            this.asignacionalumno.Modal();
        }
    }

    GuardarAlumno(listaalumnos:any){
        if(listaalumnos.length > 0){
            this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestroguardar",{"listacolaborador":this.colaboradorguardar, "listaalumnos":listaalumnos,"periodoevaluacionid":this.entidad.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.entidad.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid, "tipoasignacionid": this.accion.entidad.tipoasignacionid, "gradoid":this.gradoid}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.asignacionalumno.listacolaboradores = [];
                    if(this.listacolaborador.length == 0){
                        this.listacolaborador = this.colaboradorguardar;
                    }else{
                        for(let col of this.colaboradorguardar){
                            this.listacolaborador.push(col);
                        }
                    }
                    this.colaboradorguardar = [];
                    this.colaborador.listcolaboradorduplicado = [];
                    this.asignacionalumno.periodoevaluacionportipoevaluacionid = 0;
                    this.asignacionalumno.gradoid = 0;
                    this.colaborador.CerrarModal();
                    this.asignacionalumno.CerrarModal();
                    this.SetPadreMaestro();
                }
            })
        }
    }

    SetPadreMaestro(){
        this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestro",{"periodoevaluacionid":this.entidad.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.entidad.cicloid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid, "gradoid":this.accion.entidad.gradoid}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.Datapadresmaestros = res.data.lista;
                if(this.listacolaborador.length == 0){
                    this.listacolaborador = res.data.listacolaborador;
                }
            }
        })
    }

    Modal(){
        this.colaborador.solomaestros = [0,2];
        this.colaborador.listcolaboradorduplicado = this.listacolaborador;
        this.colaborador.seleccionMultiple = true;
        this.colaborador.colaboradorconpuesto = 1;
        this.colaborador.nivelid = this.nivelid;
        this.colaborador.nivel = this.accion.entidad.nivel;
        this.colaborador.cicloid = this.cicloid;
        this.colaborador.gradoid = this.accion.entidad.gradoid;
        this.colaborador.Modal()
    }

    ModalInterno(){
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
    }

    Eliminar(e:any){
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                let valor = [];
                if(e.data.items){
                    if(e.data.items[0].items){
                        valor = e.data.items[0].items[0];
                    }else if(e.data.items[0].collapsedItems){
                        valor = e.data.items[0].collapsedItems[0];
                    }
                }
                else if(e.data.collapsedItems){
                    if(e.data.collapsedItems[0].items){
                        valor = e.data.collapsedItems[0].items[0];
                    }else if(e.data.collapsedItems[0].collapsedItems){
                        valor = e.data.collapsedItems[0].collapsedItems[0];

                    }
                }
                this.appService.Delete("planeacion/asignacionevaluacion/padre/padremaestro/eliminar/" + valor.asignacionevaluacionpadrepormaestroid).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                        this.listacolaborador = [];
                        this.SetPadreMaestro();
                    }
                })
            }
        })
    }

    EliminarGrado(e:any){
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                let valor = [];
                if(e.data.items){
                valor = e.data.items[0];
                }
                else if(e.data.collapsedItems){
                    valor = e.data.collapsedItems[0];
                }
                this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestroporgrupo/eliminar", {"entidad":valor, "periodoevaluacionid":this.entidad.periodoevaluacionid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid, "nivelid":this.nivelid, "cicloid":this.entidad.cicloid}).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                        this.listacolaborador = [];
                        this.SetPadreMaestro();
                    }
                })
            }
        })
    }

    Formulario(e:any){
        let valor = [];
        if(e.data.items){
            if(e.data.items[0].items){
                valor = e.data.items[0].items[0];
            }else if(e.data.items[0].collapsedItems){
                valor = e.data.items[0].collapsedItems[0];
            }
        }
        else if(e.data.collapsedItems){
            if(e.data.collapsedItems[0].items){
                valor = e.data.collapsedItems[0].items[0];

            }else if(e.data.collapsedItems[0].collapsedItems){
                valor = e.data.collapsedItems[0].collapsedItems[0];

            }
        }
        let colaborador = {"colaboradorid":valor.colaboradorid, "nombreypuesto":valor.colaborador, "puestoid":valor.puestoid, "asignacionevaluacionpadrepormaestroid": valor.asignacionevaluacionpadrepormaestroid, "materiaid":valor.materiaid};
        this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestro",{"periodoevaluacionid":this.entidad.periodoevaluacionid,"nivelid":this.nivelid, "cicloid":this.entidad.cicloid, "colaboradorid":valor.colaboradorid, "puestoid":valor.puestoid, "periodoevaluacionportipoevaluacionid":this.periodoevaluacionportipoevaluacionid, "gradoid":this.accion.entidad.gradoid}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.asignacionalumno.listacolaboradores = [];
                this.colaboradorguardar.push(colaborador);
                this.asignacionalumno.listacolaboradores.push(colaborador);
                this.asignacionalumno.gradoid = this.accion.entidad.gradoid;
                this.asignacionalumno.periodoevaluacionportipoevaluacionid = this.periodoevaluacionportipoevaluacionid;
                this.asignacionalumno.Editar(res.data.lista);
            }
        })
    }

    CerrarModalInterno(){
        this.animacion = this.sistemaService.animacionCerrarModal;
        this.cantidadalumnoaleatorio = 0;
        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    GuardarCantidad(){
        if(this.cantidadalumnoaleatorio > 0){
            this.condicion = true;
            this.Modal();
        }else{
            this.condicion = false;
            this.mensajeService.Alerta(AlertaEnum.Warning,"Asigne un numero mayor a 0");
        }
    }

    onRowPrepared(e: any) {
        if (e.rowType === "group" && e.groupIndex == 0) {
            let grupos:any[] = e.data.items ? e.data.items : e.data.collapsedItems;
            let total = grupos.reduce((accumulator, currentValue) =>
                accumulator + (currentValue.items ? currentValue.items : currentValue.collapsedItems as any[]).length, 0);
            e.data.total = total;
        }
    }

    Salir() {
      this.cambio = true;
        this.output.next(this.cambio);
    }

    Guardar() {
        if (this.selectedRows.length > 0) {
            let info = {"cicloid": this.entidad.cicloid, "periodoevaluacionid": this.entidad.periodoevaluacionid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid, "tipoasignacionid": this.accion.entidad.tipoasignacionid, "listamaterias": this.selectedRows};
            this.appService.Post("planeacion/asignacionevaluacion/padre/padremaestroguardar", info).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.cambio = true;
                    this.output.next(this.cambio);
                }
            })
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Tienes que seleccionar mínimo una materia a evaluar");
        }
    }
}
